import script from "./UsageTutorial.vue?vue&type=script&setup=true&lang=js"
export * from "./UsageTutorial.vue?vue&type=script&setup=true&lang=js"

import "./UsageTutorial.vue?vue&type=style&index=0&id=4e2e965a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2e965a"]])

export default __exports__